import {
    Dialog,
    DialogActions,
    DialogBody,
    DialogTitle,
} from "@/catalyst/dialog";
import { ReactNode } from "react";

export { DialogActions as ModalActions };

export default function Modal({
    open,
    title,
    description,
    onClose,
    children,
    size = "lg",
    className,
    bodyClassName,
}: {
    open: boolean;
    title?: ReactNode;
    description?: ReactNode;
    onClose: () => void;
    children?: ReactNode;
    size?: React.ComponentProps<typeof Dialog>["size"];
    className?: string;
    bodyClassName?: string;
}) {
    return (
        <Dialog open={open} className={className} onClose={onClose} size={size}>
            {title && <DialogTitle>{title}</DialogTitle>}
            {description && (
                <div
                    className={
                        "mt-2 text-pretty text-base/6 text-zinc-500 sm:text-sm/6 dark:text-zinc-400"
                    }
                >
                    {description}
                </div>
            )}
            {children && (
                <DialogBody className={bodyClassName}>{children}</DialogBody>
            )}
        </Dialog>
    );
}
